/*global tooltip, analyticEventTracker */

const topicLabelMap = {
    'Driver requirements': 'driver_reqs',
    'Security Deposit': 'security_deposit',
    'Payment Policy': 'payment_policy',
    'Protection': 'protection',
    'Cross-border policy': 'geo_ferry_rules',
    'Rate includes': 'rc_rate_includes',
    'Rate excludes': 'rc_rate_excludes',
    'Optional extras and services': 'rc_opt_extras',
    'Fuel policy': 'rc_fuel_policy',
    'Rental period': 'rc_rental_period',
    'Business hours': 'rc_business_hours',
    'Additional information': 'additional_info'
};

var myModal = {
    options: {},
    modalId: '',
    init: function() {
        myModal.clickToOpen();
        myModal.commonActions();
        myModal.closeAction();
        myModal.accordion();
    },
    accordion: function() {
        $('body').on('click', '.car-detail-terms-header, .car-detail-terms-header-v2', function() {
            const that = $(this);

            if (that.hasClass('car-detail-terms-show-more')) {
                that.hide();
                that.toggleClass('opened').next().show();
            } else if (!that.hasClass('no-arrow')) {
                $(this).toggleClass('opened').next().slideToggle();
            }

            let label = (typeof that.data('eventLabel') !== 'undefined' ? that.data('eventLabel') : 'unknown');

            let analyticsPostData = {
                eventName: 'Rental_Condition_Viewed',
                attributes: {
                    'attributeTopicClicked': label
                }
            };

            analyticEventTracker.trackEvent(analyticsPostData);
        });
    },
    commonActions: function() {
        $('body').on('click', '.link-to-deposit', function(e) {
            e.preventDefault();
            $('#payment-policy-header').removeClass('opened');
            $('#payment-policy-body').hide();
            $('.modal-body').animate({ scrollTop: 0 }, 'slow');
            $('#payment-deposit-header').addClass('opened');
            $('#payment-deposit-body').show();
        });
    },
    clickToOpen: function() {
        $('body').on('click', '.open-modal', function(e) {
            e.preventDefault();
            var element = $(this),
                url = element.attr('href');

            myModal.options.title = element.data('title');
            myModal.options.class = (typeof element.data('class') !== 'undefined' ? element.data('class') : 'default');
            myModal.options.closeOutside = (typeof element.data('outside') !== 'undefined' ? element.data('outside') : true);
            myModal.options.gtmEvent = (typeof element.data('gtm-event') !== 'undefined' ? element.data('gtm-event') : false);
            myModal.options.openModalOnClose = (typeof element.data('open-modal-on-close') !== 'undefined' ? element.data('open-modal-on-close') : false);
            myModal.options.openAlternativeModalBack = (Boolean(typeof element.hasClass('isAlternative')));

            myModal.openModal(url);

        }).on('click', '.open-static-modal', function(e) {
            e.preventDefault();
            let options = {};
            const element = $(this);

            options.modalWindowClass = (typeof element.data('class') !== 'undefined' ? element.data('class') : 'w-600');
            options.closeOutside = (typeof element.data('outside') !== 'undefined' ? element.data('outside') : true);

            if (typeof element.data('title') !== 'undefined') {
                options.title = element.data('title');
            }

            myModal.staticModal($(this).data('layout'), options);
        });
    },
    openModal: function(url) {

        var mWindow = $('.modal'),
            mHeader = $('.modal-header'),
            mDialog = $('.modal-dialog'),
            mBody = $('.modal-body'),
            close = $('.modal-close'),
            mLoadData = $('.modal-load-data'),
            pBody = '',
            lang = '',
            textDirection = '';

        tooltip.hide();
        mWindow.fadeIn(400);
        mDialog.removeClass().addClass('modal-dialog').addClass(myModal.options.class);
        mBody.removeClass().addClass('modal-body');

        $('body').addClass('modal-open');

        mHeader.removeClass('no-border').html(myModal.options.title).show();
        close.show();
        mLoadData.show();
        mBody.html('');
        mBody.attr('lang', lang);
        mBody.attr('dir', textDirection);

        $.getJSON(url, function(response) {
            if (response.error) {
                pBody = response.message;
            } else {
                pBody = response.data.body;
                lang = response.data.lang;
                textDirection = response.data.textDirection;
            }

            mLoadData.hide();
            mBody.html(pBody);
            mBody.attr('lang', lang);
            mBody.attr('dir', textDirection);
            tooltip.modal();
            // validateBooking.init();
            mBody.show();
        });

        if (myModal.options.gtmEvent) {

            if (myModal.options.gtmEvent === 'saveForLater') {
                close.attr('data-event-action', 'Close');
                close.addClass('trigger-gtm-sfr');
            }
        }

        // close modal if clicked outside
        if (myModal.options.closeOutside) {
            $(document).on('click', '.modal', function(e) {
                //detect a click outside an element
                if (!$(e.target).closest('.modal-dialog').length) {
                    myModal.close();
                }
            });
        }
    },
    openStaticModal: function(layout, options) {
      this.staticModal(layout, options);
    },
    staticModal: function(layout, options) {
        var mWindow = $('.modal'),
            mHeader = $('.modal-header'),
            mBody = $('.modal-body'),
            mDialog = $('.modal-dialog'),
            mLoadData = $('.modal-load-data'),
            pBody = $('#' + layout).html(),
            closeOutside = false,
            mWindowClass = (typeof options !== 'undefined' && Object.prototype.hasOwnProperty.call(options, 'modalWindowClass') ? options.modalWindowClass : ''),
            mDialogClass = (typeof options !== 'undefined' && Object.prototype.hasOwnProperty.call(options, 'modalDialogClass') ? options.modalDialogClass : 'w-600'),
            mBodyClass = (typeof options !== 'undefined' && Object.prototype.hasOwnProperty.call(options, 'modalBodyClass') ? options.modalBodyClass : '');

        myModal.modalId = layout;
        mWindow.fadeIn(400);
        mWindow.removeClass().addClass('modal').addClass(mWindowClass);
        mDialog.removeClass().addClass('modal-dialog').addClass(mDialogClass);
        mBody.removeClass().addClass('modal-body').addClass(mBodyClass);
        $('body').addClass('modal-open');

        if (typeof options !== 'undefined' && Object.prototype.hasOwnProperty.call(options, 'title')) {
            if (Object.prototype.hasOwnProperty.call(options, 'noBorder')) {
                mHeader.addClass('no-border').html(options.title);
            } else {
                mHeader.removeClass('no-border').html(options.title);
            }

        } else if (typeof options !== 'undefined' && Object.prototype.hasOwnProperty.call(options, 'onlyClose')) {
            mHeader.hide();
            $('.modal-close').show();
        } else {
            mHeader.addClass('no-border').html('');
            $('.modal-close').hide();
        }

        if (typeof options !== 'undefined' && Object.prototype.hasOwnProperty.call(options, 'noHeader')) {
            $('.modal-header').hide();
        } else {
            $('.modal-header').show();
        }

        if (typeof options !== 'undefined' && Object.prototype.hasOwnProperty.call(options, 'noCloseButtonInHeader')) {
            $('.modal-close').hide();
        } else {
            $('.modal-close').show();
        }

        if (typeof options !== 'undefined' && Object.prototype.hasOwnProperty.call(options, 'noHeader')) {
            mHeader.hide();
        }

        if (typeof options !== 'undefined' && Object.prototype.hasOwnProperty.call(options, 'gtmEvent')) {
            var close = $('.modal-close');

            if (options.gtmEvent === 'modifyRequest') {
                close.attr('data-event-action', 'Close');
                close.addClass('trigger-gtm-mr');
            } else if (options.gtmEvent === 'cancellationRequest') {
                close.attr('data-event-action', 'Close');
                close.addClass('trigger-gtm-cancellation');
            }
        }

        if (typeof options !== 'undefined' && Object.prototype.hasOwnProperty.call(options, 'closeOutside')) {
            closeOutside = true;
        }

        mLoadData.hide();
        mBody.html('').html(pBody);

        if (typeof options !== 'undefined' && Object.prototype.hasOwnProperty.call(options, 'msg')) {
            $('.ajax-loaded-content').html(options.msg);
        }

        mBody.show();

        // close modal if clicked outside
        if (myModal.options.closeOutside || closeOutside) {
            $(document).on('click', '.modal', function(e) {
                //detect a click outside an element
                if (!$(e.target).closest('.modal-dialog').length) {

                    if (typeof options !== 'undefined' && Object.prototype.hasOwnProperty.call(options, 'reloadToMyBooking')) {
                        window.location.href = _d.url.c.replace('/modify/', '/show/');
                    } else {
                        myModal.close();
                    }

                    if (typeof options !== 'undefined' && Object.prototype.hasOwnProperty.call(options, 'gtmEvent')) {
                        if (options.gtmEvent === 'rateUsClose') {
                            dataLayer.push({
                                'event': 'rateUsClose'
                            });
                        }
                    }
                }
            });
        }
    },
    mapModal: function() {
        var mWindow = $('#pickUpMapModal'),
            mBody = $('.modal-body');

        mWindow.fadeIn(400);
        mWindow.removeClass().addClass('modal w-900');
        $('body').addClass('modal-open');
        mBody.show();

        // close modal if clicked outside
        if (myModal.options.closeOutside) {

            $(document).on('click', '.modal', function(e) {
                //detect a click outside an element
                if (!$(e.target).closest('.modal-dialog').length) {
                    myModal.close();
                }
            });
        }
    },
    closeAction: function() {

        $(document).keyup(function(e) {
            if (e.keyCode === 27) {
                $('.modal-close').trigger('click');
            }
        });

        $('body').on('click', '.modal-close', function(e) {
            e.preventDefault();
            var that = $(this);

            if (that.hasClass('redirect-to-home')) {
                window.location = _d.url.bh;
            } else if (that.hasClass('reload')) {
                window.location.href = _d.url.c;
            } else if (myModal.options.openModalOnClose) {
                myModal.close();
                setTimeout(function() {
                    myModal.staticModal(myModal.options.openModalOnClose, {noHeader: true});
                    myModal.options.openModalOnClose = false;
                }, 800);
            } else if (myModal.options.openAlternativeModalBack) {
                myModal.close();
                setTimeout(function() {
                    $('#reservationViewAlternative').click();
                    myModal.options.openAlternativeModalBack = false;
                }, 800);
            } else {
                myModal.close();
            }
        }).on('click', '.trigger-mc', function(e) {
            e.preventDefault();
            var modalClose = $('.modal-close');

            if ($(this).hasClass('redirect')) {
                modalClose.addClass('redirect-to-home');
            }
            if ($(this).hasClass('reload')) {
                modalClose.addClass('reload');
            }

            modalClose.click();
        }).on('click', '.trigger-f5', function(e) {
            e.preventDefault();
            location.reload();
        });
    },
    close: function(duration = 400) {
        $('.modal').fadeOut(duration, function() {
            $('body').removeClass('modal-open');
            $('.modal-body').hide();
            history.pushState('', document.title, _d.url.c);
            $('.button.loading').removeClass('loading');
            $(document).trigger('modalClosed', [myModal.modalId]);
        });
    }
};
